export default "<iframe id=\"iframe\" width=\"100%\" src=\"\" frameborder=\"0\" allowFullScreen=\"true\"></iframe>";